import template from './client-address.html';
import controller from './client-address.controller';

const clientAddressComponent = {
  bindings: {
    model: '=',
    title: '<',
    editing: '<',
    required: '<'
  },
  template,
  controller
};

export default clientAddressComponent;
